import React from 'react';
import { withRouter, } from 'react-router';
import Page from '../templates/Page';
import ButtonAction from '../components/utilities/ButtonAction';
var selfStyles = require('./styles.scss');
var PageErrorNotFound = function (props) { return (React.createElement(Page, { documentTitle: 'Error', pageTitle: '', isWaiting: false, isError: true, errorTitle: 'Something went wrong', errorMessage: (React.createElement(React.Fragment, null,
        props.errorMessage && React.createElement("div", { className: selfStyles.message }, props.errorMessage),
        React.createElement(ButtonAction, null,
            React.createElement("button", { onClick: props.history.goBack },
                React.createElement("strong", null, "Go back!"))))) })); };
export default withRouter(PageErrorNotFound);



//////////////////
// WEBPACK FOOTER
// ./src/pages/PageErrorNotFound/index.tsx
// module id = 375
// module chunks = 0